import { shape, arrayOf, number } from "prop-types"

export const chartDomain = shape({
    x: arrayOf(number.isRequired).isRequired,
    y: arrayOf(number.isRequired).isRequired,
    zoomedXDomain: arrayOf(number.isRequired).isRequired,
})
